import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddBranchLayer from "../../../components/Admin/AddBranchLayer.jsx";

const AddBranch = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddBranchLayer />
      </MasterLayout>
    </>
  );
};

export default AddBranch;
